import { wasteDirectionEnum } from "../waste";

export const getWasteDirectionLabel = (direction: number): string => {
    switch (direction) {
        case wasteDirectionEnum.IN:
            return 'incoming';
        case wasteDirectionEnum.OUT:
            return 'outgoing';
        default:
            return 'unknown';
    }
};
